import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../breedAction';
import fetchApi from "./fetchApi";

function fetchBreedAction() {
  var milliseconds = new Date().getTime();
  return fetchApi('/v1/fc_api/breed_resource?c=' + milliseconds, fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchBreedAction;
